module.exports = __webpack_public_path__ + "img/clientes.4582ed05.jpg";